import { DataType } from '@/constants/validationTypes';
import { extractDataType, encodeFieldKey } from '../validation/ValidationSchemaGenerator';
import { ComponentValue, Field } from '../sceneDataSchema';
import { stringConverter } from './StringConverter';
import { numberConverter } from './NumberConverter';
import { booleanConverter } from './BooleanConverter';
import { FormValues } from '@/constants/formTypes';
// import { dateConverter } from "./dateConverter";

export function convertToFieldDateType(data: FormValues, fields: Field[]): FormValues {
  const converted_data: FormValues = {};
  for (const key in data) {
    const value = data[key];
    const component = fields.find((component) => encodeFieldKey(component) === key);
    if (component) {
      converted_data[key] = convertValue(value, extractDataType(component));
    } else {
      console.log('Component not found, but continuing');
      converted_data[key] = value;
    }
  }
  return converted_data;
}

export function convertEmptyStringsToNull(data: FormValues): FormValues {
  const converted_data: FormValues = {};
  for (const key in data) {
    const value = data[key];

    if (value === '') {
      converted_data[key] = null;
      continue;
    }
    converted_data[key] = value;
  }
  return converted_data;
}

export function convertValue(value: ComponentValue, data_type: DataType) {
  switch (data_type) {
    case DataType.String:
      return stringConverter(value);
    case DataType.Integer:
      return numberConverter(value);
    case DataType.Boolean:
      return booleanConverter(value);
    case DataType.Date:
      return value;
    default:
      // TODO: Add new error logger here that will blow up on local but silently fail on production
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      console.error(`Unsupported data type: ${data_type}`);
      return value;
  }
}
